import React, {useLayoutEffect} from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5locales_it_IT from "@amcharts/amcharts5/locales/it_IT"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import {getTooltip, getXYChart, addCursor, getRenderAxisX, getRenderAxisY} from "./commons";


function KpiWorksiteBarChart({id, data, intl}) {

  const cantieri = intl.formatMessage({id: 'worksites'})
  const amount = intl.formatMessage({id: 'total_amount_kk'})

  useLayoutEffect(() => {

    let root = am5.Root.new(id);
    root.setThemes([am5themes_Animated.new(root)])
    root.locale = am5locales_it_IT;
    root.numberFormatter.set("numberFormat", "#,###.");

    // Create chart
    let chart = getXYChart(root, {layout: root.verticalLayout})
    addCursor(root, chart)

    // Create axes
    let yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
      categoryField: "category",
      renderer: getRenderAxisY(root, false, true)
    }))

    let yRenderer = yAxis.get("renderer");
    yRenderer.labels.template.setAll({
      fontSize: 11,
      fontWeight: "bold",
      paddingRight: 10,
    });
    yAxis.data.setAll(data);

    let xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
      renderer: getRenderAxisX(root, false),
      extraMax: 0.15,
      min: 0
    }))
    xAxis.get("renderer").labels.template.set("forceHidden", true);


    // Add series
    function createSeries(field, name) {
      let series = chart.series.push(am5xy.ColumnSeries.new(root, {
        name: name,
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: field,
        stacked: true,
        categoryYField: "category",
        valueYField: "value",
        maskBullets: false,
        tooltip: getTooltip(root, `[bold]{categoryY}[/] \n ${amount}: {valueX}€ \n ${cantieri}: {valueY}`)
      }))

      series.columns.template.setAll({
        templateField: "settings",
        fillOpacity: 0.7,
      })

      series.bullets.push(function() {
        return am5.Bullet.new(root, {
          locationX: 1,
          locationY: 0.5,
          sprite: am5.Label.new(root, {
            centerY: am5.p50,
            text: "{valueX}€",
            populateText: true
          })
        });
      });

      series.data.setAll(data);
      series.appear(1000);

    }

    createSeries('amount', amount)

    return () => {
      root.dispose()
    }
  }, [data, id]) // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={id} className="w-full h-64"/>
}

export default React.memo(KpiWorksiteBarChart, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data)
})
